module.exports = __webpack_public_path__ + "static/media/top_prod_3.6a5bfbcb.png";